import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import Boxoutline from "../../../../../media/images/icons/outline-box";
import LocationFill from "../../../../../media/images/icons/location-fill";
import CustomButton from "../../../../components/CustomButton";
import DownloadLikeLogin from "../../../../../media/images/icons/download-likelogin";
import FerightInfo from "./FerightInfo";
import ArrowStepLeft from "../../../../../media/images/icons/arrow-steps-register";
import { addCommas, digitsEnToFa } from "@persian-tools/persian-tools";

export default function ActiveFeright() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mt: 3,
        backgroundColor: "background.default",
        borderRadius: "16px",
        boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2)",
        padding: "8px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Box
        sx={{
          padding: "8px",
          border: "1px solid #CFD8DC",
          borderRadius: "16px",
          backgroundColor: "info.light",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                backgroundColor: "background.default",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "6px",
                borderRadius: "8px",
              }}
            >
              <Boxoutline color={theme.palette.textColor.main} />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography variant="body2">
                کنستانتره سنگ آهن فلان کنستانتره سنگ آهن فلان
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "success.main",
                }}
              >
                بارنامه صادرشده
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              flexWrap: "wrap",
              gap: "6px",
              justifyContent: "end",
            }}
          >
            <Box
              sx={{
                borderColor: "info.main",
                borderWidth: "1px",
                borderStyle: "solid",
                backgroundColor: "background.default",
                padding: "2px",
                borderRadius: "6px",
              }}
            >
              <Typography noWrap variant="body2">
                {digitsEnToFa(addCommas(8000000))}
                ریال
              </Typography>
            </Box>
            <Box
              sx={{
                borderColor: "info.main",
                borderWidth: "1px",
                borderStyle: "solid",
                backgroundColor: "background.default",
                padding: "2px",
                borderRadius: "6px",
              }}
            >
              <Typography noWrap variant="body2">
                {digitsEnToFa(10)}
                تن
              </Typography>
            </Box>
            <Box
              sx={{
                borderColor: "info.main",
                borderWidth: "1px",
                borderStyle: "solid",
                backgroundColor: "background.default",
                padding: "2px",
                borderRadius: "6px",
              }}
            >
              <Typography noWrap variant="body2">
                بسته‌بندی
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            mt: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "background.default",
            padding: "8px",
            borderRadius: "8px",
            borderColor: "info.main",
            borderWidth: "1px",
            borderStyle: "solid",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <LocationFill color={theme.palette.primary.main} />
            <Typography
              variant="body2"
              sx={{
                color: "primary.main",
              }}
            >
              کهگلویه و بویراحمد
            </Typography>
          </Box>
          <ArrowStepLeft color={theme.palette.textColor.main} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <LocationFill color={theme.palette.secondary.main} />
            <Typography
              variant="body2"
              sx={{
                color: "secondary.main",
              }}
            >
              سیستان و بلوچستان{" "}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
        }}
      >
        <CustomButton
          title="دریافت فایل بارنامه"
          bgColor="success.main"
          fSize="14px"
          px="6px"
          py="4px"
          borderRadius="6px"
          color="darkStatic.main"
          icon2={<DownloadLikeLogin color={"#fff"} />}
        />
        <CustomButton
          title="دریافت فایل مجوز"
          bgColor="success.main"
          fSize="14px"
          px="6px"
          py="4px"
          borderRadius="6px"
          color="darkStatic.main"
          icon2={<DownloadLikeLogin color={"#fff"} />}
        />
      </Box>
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 8px",
          backgroundColor: "secondary.light",
          borderRadius: "8px",
        }}
      >
        <Typography
          sx={{
            color: "secondary.main",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          کد رهگیری بارنامه:
        </Typography>
        <Typography
          sx={{
            color: "secondary.main",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          292929555955592955592929295559299
        </Typography>
      </Box> */}
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 8px",
          backgroundColor: "primary.light",
          borderRadius: "8px",
        }}
      >
        <Typography
          sx={{
            color: "primary.main",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          کد رهگیری بارنامه:
        </Typography>
        <Typography
          sx={{
            color: "primary.main",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          292929555955592955592929295559299
        </Typography>
      </Box> */}
      <FerightInfo />
    </Box>
  );
}
